import React from "react";
import { Oval } from "react-loader-spinner"

export default function Loading() {
    return (
        <Oval
            color="#aaa"
            height={40}
            width={40}
        />
    );
}
